import React, { useEffect, useRef } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import bunnycloud from './assets/bunnycloud.png';  
import amulet from './assets/Amulet.jpeg';
import anthropology from './assets/anthropology.png';
import articuno from './assets/articuno.png';
import beanbean from './assets/beanbean.png';
import butterfly from './assets/butterfly.png';
import moltres from './assets/moltres.png';
import paintingAustralia from './assets/paintingAustralopithicus.jpeg';
import zapdo from './assets/zapdo.png';
import tomatocats from './assets/tomatocats.jpg';
import siamese from './assets/siamese.jpg';
import dusty from './assets/dusty.jpg';
import mikupotato from './assets/mikupotato.jpg';
import mikubag from './assets/mikubag.jpg';

const items = [
  { id: 1, image: bunnycloud, title: 'Bunny Cloud', description: 'A fluffy bunny cloud.' },
  { id: 2, image: amulet, title: 'Amulet', description: 'A magical amulet image.' },
  { id: 3, image: anthropology, title: 'Anthropology', description: 'Anthropology image.' },
  { id: 4, image: paintingAustralia, title: 'Australia Painting', description: 'A painting of Australia.' },
  { id: 5, image: articuno, title: 'Articuno', description: 'Legendary bird Articuno.' },
  { id: 6, image: zapdo, title: 'Zapdos', description: 'Legendary bird Zapdos.' },
  { id: 7, image: moltres, title: 'Moltres', description: 'Legendary bird Moltres.' },
  { id: 8, image: beanbean, title: 'Bean Bean', description: 'A cute bean character.' },
  { id: 9, image: butterfly, title: 'catfly', description: 'Colorful butterfly image.' },
  { id: 10, image: tomatocats, title: 'Pocket Home', description: 'Pocket home design.' },
  { id: 11, image: dusty, title: 'Pocket Home', description: 'Pocket home design.' },
  { id: 12, image: siamese, title: 'Pocket Home', description: 'Pocket home design.' },
  { id: 13, image: mikupotato, title: 'Pocket Home', description: 'Pocket home design.' },
  { id: 14, image: mikubag, title: 'Pocket Home', description: 'Pocket home design.' },
];
export default function ArtPiece() {
  const { id } = useParams();
  const { hash } = useLocation();      // will be "#focus" from the Gallery links
  const imgRef = useRef(null);

  const itemId = Number(id);
  const itemIndex = items.findIndex(p => p.id === itemId);

  // Run the hook unconditionally; guard *inside* it.
  useEffect(() => {
    const el = imgRef.current;
    if (!el) return;
    const scrollToCenter = () =>
      el.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'nearest' });

    if (el.complete) scrollToCenter();
    else el.addEventListener('load', scrollToCenter, { once: true });

    return () => el.removeEventListener?.('load', scrollToCenter);
  }, [hash, itemIndex]);

  if (itemIndex === -1) return <div>Art piece not found!</div>;

  const nextIndex = (itemIndex + 1) % items.length;
  const prevIndex = (itemIndex - 1 + items.length) % items.length;
  const current   = items[itemIndex];

  return (
    <div className="art-piece-detail">
      <img
        ref={imgRef}
        id="focus"
        src={current.image}
        alt={current.title}
        className="art-piece-image"
      />
      <h1>{current.title}</h1>

      <div className="navigation-buttons">
        <Link to={`/art/${items[prevIndex].id}#focus`} className="arrow left-arrow">←</Link>
        <Link to={`/art/${items[nextIndex].id}#focus`} className="arrow right-arrow">→</Link>
      </div>

      <Link to="/gallery" className="back-button">Back to Gallery</Link>
    </div>
  );
}